import React, { useState, useEffect } from "react";
import BirthDateSelect from "./form_fields/birth_date_select";
import Checkbox from "./form_fields/checkbox_input";
import Cleave from "cleave.js/react";
import CountryCodeSelect from "./form_fields/country_code_select";
import DateDropdown from "./form_fields/date_dropdown";
import EmailInput from "./form_fields/email_input";
import EmergencyContactInput from "./form_fields/emergency_contact_input";
import EmergencyContactNumberInput from "./form_fields/emergency_contact_number_input";
import GradeInput from "./form_fields/grade_input";
import GradePointAverageField from "./form_fields/grade_point_average_field";
import GradYearSelect from "./form_fields/grad_year_select";
import HeightInput from "./form_fields/height_input";
import PhysicianContactNumberInput from "./form_fields/physician_contact_number_input";
import PhysicianInfoForm from "./form_fields/physician_info_form";
import PositionSelect from "./form_fields/position_select";
import SatScoreField from "./form_fields/sat_score_field";
import ActScoreField from "./form_fields/act_score_field";
import StateSelectField from "./form_fields/state_select_field";
import TshirtField from "./form_fields/tshirt_field";
import TextArea from "./form_fields/text_area_input";
import TextField from "./form_fields/text_field";
import TextInput from "./form_fields/text_input";
import WeightInput from "./form_fields/weight_input";
import AgeGroupSelect from "./form_fields/age_group_select";
import TeammatesCollectionField from "./form_fields/teammates_collection_field";
import URLField from "./form_fields/url_field";
import YearsInSportField from "./form_fields/years_in_sport_field";
import YearsOfTrainingField from "./form_fields/years_of_training_field";
import PhoneNumberInput from "./form_fields/phone_number_input";
import GenderSelectField from "./form_fields/gender_select_field";

const CustomInfoForm = ({
  collectGuardianInfo,
  existingCamperId,
  existingAttendeeData,
  campers,
  emergencyContact,
  sport,
  event_type,
  full_position_price_points,
  price_points,
  data_points,
  category,
  saveValues,
  nextStep,
  buttonStyles,
}) => {
  const [formData, setFormData] = useState({
    showModal: null,
    first_name: "",
    last_name: "",
    birth_date: "",
    playerPhoneNumber: "",
    emergencyContact: "",
    emergencyContactCountryCode: "+1",
    emergencyContactNumber: "",
    gender: "",
    grade: "",
    guardianContact: "",
    guardianContactCountryCode: "+1",
    guardianContactNumber: "",
    guardianContactEmail: "",
    guardianContactRelationship: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    price_points: {},
    physician: "",
    physician_contact_number: "",
    insurer: "",
    group_number: "",
    medications: "",
    conditions: "",
    allergies: "",
    diabetes: false,
    asthma: false,
    height: "",
    weight: "",
    position: "",
    gpa: "",
    sat: "",
    act_score: "",
    club_team: "",
    user_notes: "",
    roommate_preference: "",
    peers_attending: "",
    graduation_year: "",
    shirt_size: "",
    custom_data: {},
  });

  const [missingRequiredFields, setMissingRequiredFields] = useState({});

  useEffect(() => {
    console.log("Debug -> data_points:", data_points);
  }, [data_points]);

  useEffect(() => {
    if (existingAttendeeData) {
      console.log("Debug -> existingAttendeeData:", existingAttendeeData);
      setFormData((prevState) => ({
        ...prevState,
        showModal: null,
        // Basic Information
        first_name: existingAttendeeData.first_name || "",
        last_name: existingAttendeeData.last_name || "",
        email: existingAttendeeData.email || "",
        birth_date: existingAttendeeData.birth_date || new Date("2006-01-01"),
        gender: existingAttendeeData.gender || "",
        grade: existingAttendeeData.grade || "",
        
        // Contact Information
        player_phone_number: existingAttendeeData.player_phone_number || "",
        address: existingAttendeeData.address || "",
        city: existingAttendeeData.city || "",
        state: existingAttendeeData.state || "",
        zip: existingAttendeeData.zip || "",
        room_number: existingAttendeeData.room_number || "",

        // Emergency Contacts
        emergency_contact: existingAttendeeData.emergency_contact || "",
        emergency_contact_number: existingAttendeeData.emergency_contact_number || "",
        emergency_contact_country_code: existingAttendeeData.emergency_contact_country_code || "+1",
        guardian_contact: existingAttendeeData.guardian_contact || "",
        guardian_contact_number: existingAttendeeData.guardian_contact_number || "",
        guardian_contact_email: existingAttendeeData.guardian_contact_email || "",
        guardian_contact_relationship: existingAttendeeData.guardian_contact_relationship || "",

        // Medical Information
        physician: existingAttendeeData.physician || "",
        physician_contact_number: existingAttendeeData.physician_contact_number || "",
        insurer: existingAttendeeData.insurer || "",
        group_number: existingAttendeeData.group_number || "",
        medications: existingAttendeeData.medications || "",
        conditions: existingAttendeeData.conditions || "",
        allergies: existingAttendeeData.allergies || "",
        diabetes: existingAttendeeData.diabetes === true,
        asthma: existingAttendeeData.asthma === true,
        sickle_cell_positive: existingAttendeeData.sickle_cell_positive === true,
        glasses_or_contacts: existingAttendeeData.glasses_or_contacts === true,
        special_needs: existingAttendeeData.special_needs === true,
        dietary_restrictions: existingAttendeeData.dietary_restrictions || "",
        physical_restrictions: existingAttendeeData.physical_restrictions || "",
        injury_history: existingAttendeeData.injury_history || "",
        history_of_concussion: existingAttendeeData.history_of_concussion === true,

        // Academic Information
        high_school: existingAttendeeData.high_school || "",
        graduation_year: existingAttendeeData.graduation_year || "",
        gpa: existingAttendeeData.gpa || "",
        sat: existingAttendeeData.sat || "",
        act_score: existingAttendeeData.act_score || "",

        // Athletic Information
        height: existingAttendeeData.height || "",
        weight: existingAttendeeData.weight || "",
        position: existingAttendeeData.position || "",
        club_team: existingAttendeeData.club_team || "",
        sports: existingAttendeeData.sports || "",
        years_in_sport: existingAttendeeData.years_in_sport || "",
        years_of_training: existingAttendeeData.years_of_training || "",
        training_experience: existingAttendeeData.training_experience || "",
        goals: existingAttendeeData.goals || "",

        // Social Media Profiles
        tik_tok_profile_url: existingAttendeeData.tik_tok_profile_url || "",
        instagram_profile_url: existingAttendeeData.instagram_profile_url || "",
        hudl_profile_url: existingAttendeeData.hudl_profile_url || "",
        facebook_profile_url: existingAttendeeData.facebook_profile_url || "",
        youtube_profile_url: existingAttendeeData.youtube_profile_url || "",

        // Camp Specific Information
        roommate_preference: existingAttendeeData.roommate_preference || "",
        peers_attending: existingAttendeeData.peers_attending || "",
        shirt_size: existingAttendeeData.custom_data?.shirt_size || "",
        age_group_select: existingAttendeeData.age_group_select || "",

        // Additional Information
        notes: existingAttendeeData.custom_data?.notes || "",
        user_notes: existingAttendeeData.custom_data?.user_notes || "",
        price_points: existingAttendeeData.price_points || {},
        custom_data: existingAttendeeData.custom_data || {},
      }));
    }
  }, [existingAttendeeData]);
  
  useEffect(() => {
    data_points.forEach((dp) => {
      if (dp.force_recollection) {
        setFormData((prev) => ({
          ...prev,
          [dp.field_name]: getDefaultValue(dp),
        }));
      }
    });
  }, [data_points]);

  const getMissingFieldLabels = () => {
     const missing = data_points.filter((dp) => {
       if (!dp.required) {
         return false;
       }
       const value = formData[dp.field_name];
       const isBoolean =
         dp.field_type === "boolean" ||
         dp.field_type === "checkbox" ||
         dp.field_name === "asthma" ||
         dp.field_name === "diabetes";

       if (isBoolean) {
         return value !== true && value !== false; 
       }
       if (!value || value.toString().trim().length === 0) {
         return true;
       }
       return false;
     });

     return missing.map(dp => {
        const rawLabel = dp.field_label || dp.field_name || "Unnamed Field";
        return humanizeFieldLabel(rawLabel);
      });
   };

   const allRequiredFieldsFilled = () => {
     const missingLabels = getMissingFieldLabels();
     return missingLabels.length === 0;
   };

   const humanizeFieldLabel = (label) => {
     // First replace underscores with spaces
     let humanized = label.replace(/_/g, ' ');

     // Handle special cases for common abbreviations
     humanized = humanized
       .replace(/\bgpa\b/i, 'GPA')
       .replace(/\bsat\b/i, 'SAT')
       .replace(/\bact\b/i, 'ACT')
       .replace(/\burl\b/i, 'URL');

     // Capitalize first letter of each word
     return humanized
       .split(' ')
       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
       .join(' ');
   };

  const handleSubmit = (e) => {
    e.preventDefault();

    let missingFieldsObj = {};
    data_points.forEach((dp) => {
      if (dp.required) {
        const fieldValue = formData[dp.field_name];
        const isBoolean =
          dp.field_type === "boolean" ||
          dp.field_type === "checkbox" ||
          dp.field_name === "asthma" ||
          dp.field_name === "diabetes";

        if (!isBoolean) {
          if (!fieldValue || fieldValue.toString().trim().length === 0) {
            missingFieldsObj[dp.field_name] = true;
          }
        } else if (fieldValue !== true && fieldValue !== false) {
          missingFieldsObj[dp.field_name] = true;
        }
      }
    });

    if (Object.keys(missingFieldsObj).length > 0) {
      console.log("Debug -> Missing required fields:", missingFieldsObj);
      setMissingRequiredFields(missingFieldsObj);
      return;
    }

    console.log("Debug -> All required fields satisfied. Proceeding...");
    const data = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      birth_date: formData.birth_date,
      gender: formData.gender,
      email: formData.email,
      player_phone_number: formData.player_phone_number,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      physician: formData.physician,
      physician_contact_number: formData.physician_contact_number,
      physician_city: formData.physician_city,
      insurer: formData.insurer,
      insurer_phone_number: formData.insurer_phone_number,
      insurance_policy_holder: formData.insurance_policy_holder,
      group_number: formData.group_number,
      medications: formData.medications,
      conditions: formData.conditions,
      allergies: formData.allergies,
      diabetes: formData.diabetes,
      asthma: formData.asthma,
      sickle_cell_positive: formData.sickle_cell_positive,
      glasses_or_contacts: formData.glasses_or_contacts,
      special_needs: formData.special_needs,
      emergency_contact: formData.emergency_contact,
      emergency_contact_number: formData.emergency_contact_number,
      height: formData.height,
      weight: formData.weight,
      position: formData.position,
      grade: formData.grade,
      gpa: formData.gpa,
      sat: formData.sat,
      act_score: formData.act_score,
      club_team: formData.club_team,
      high_school: formData.high_school,
      roommate_preference: formData.roommate_preference,
      peers_attending: formData.peers_attending,
      dietary_restrictions: formData.dietary_restrictions,
      physical_restrictions: formData.physical_restrictions,
      injury_history: formData.injury_history,
      training_experience: formData.training_experience,
      goals: formData.goals,
      sports: formData.sports,
      years_in_sport: formData.years_in_sport,
      years_of_training: formData.years_of_training,
      vaccinated: formData.vaccinated,
      vaccine_type: formData.vaccine_type,
      vaccine_dose_one_date: formData.vaccine_dose_one_date,
      vaccine_dose_two_date: formData.vaccine_dose_two_date,
      positive_test_date: formData.positive_test_date,
      covid_positive: formData.covid_positive,
      covid_cleared: formData.covid_cleared,
      shirt_size: formData.shirt_size,
      graduation_year: formData.graduation_year,
      liability_waiver: formData.liability_waiver,
      liability_waiver_initials: formData.liability_waiver_initials,
      liability_waiver_signature: formData.liability_waiver_signature,
      guardian_contact: formData.guardian_contact,
      guardian_contact_number: formData.guardian_contact_number,
      guardian_contact_relationship: formData.guardian_contact_relationship,
      guardian_contact_email: formData.guardian_contact_email,
      tik_tok_profile_url: formData.tik_tok_profile_url,
      instagram_profile_url: formData.instagram_profile_url,
      hudl_profile_url: formData.hudl_profile_url,
      facebook_profile_url: formData.facebook_profile_url,
      youtube_profile_url: formData.youtube_profile_url,
      custom_data: formData.custom_data || {},
    };

    saveValues(data);
    nextStep();
  };

  const positionChange = (positionValue) => {
    setFormData((prevState) => ({
      ...prevState,
      position: positionValue,
    }));
  };

  const handleChange = (e) => {
    const { name, type } = e.target;
    const value = type === "checkbox" ? e.target.checked : e.target.value;

    if (name in formData.custom_data) {
      setFormData((prev) => ({
        ...prev,
        custom_data: {
          ...prev.custom_data,
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const formatFieldName = (fieldName) => {
    return fieldName.replace(/(^|_)\w/g, (match) =>
      match.replace("_", "").toUpperCase()
    );
  };

  const propsForField = (dp) => {
    switch (dp.field_name) {
      case "state":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          state: formData.state || "",
          required: dp.required,
          forceRecollection: dp.force_recollection,
          onChange: stateDropdownChanged,
        };
      case "birth_date":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          required: dp.required,
          onChange: handleChange,
        };
      case "position":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          required: dp.required,
          onChange: positionChange,
        };
      case "height":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          required: dp.required,
          onChange: handleChange,
        };
      case "club_team":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          placeholder: "Club Team",
          required: dp.required,
          onChange: handleChange,
        };
      case "asthma":
      case "diabetes":
      case "boolean":
      case "checkbox":
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          checked: formData[dp.field_name] || false,
          value: formData[dp.field_name] || "",
          required: dp.required,
          onChange: handleChange,
        };
      default:
        return {
          key: dp.id,
          label: dp.field_label || formatFieldName(dp.field_name),
          name: dp.field_name,
          value: formData[dp.field_name] || "",
          required: dp.required,
          onChange: handleChange,
        };
    }
  };

  // Apply a .missing-required class if the field is missing
  // and add aria-invalid="true" for screen readers
  const renderField = (dp) => {
    const fieldProps = propsForField(dp);
    const isMissing = missingRequiredFields[dp.field_name];

    // Add a CSS class if missing
    let classNames = "";
    if (isMissing) {
      classNames = "missing-required"; // CSS class to style orange border
    }

    // We can add an inline style or rely on a class in external CSS
    // For demonstration, we'll rely on the class:
    // .missing-required {
    //   border: 2px solid orange !important;
    //   border-radius: 4px;
    // }

    // Add aria-invalid and aria-describedby if missing
    const ariaProps = isMissing
      ? {
          "aria-invalid": "true",
          "aria-describedby": `error-${dp.field_name}`,
        }
      : {};

    switch (dp.field_type) {
      case "string":
        return (
          <TextField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "email":
        return (
          <EmailInput
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "height":
        return (
          <HeightInput
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "grade":
        return (
          <GradeInput
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "years_of_training":
        return (
          <YearsOfTrainingField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "years_in_sport":
        return (
          <YearsInSportField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "gpa":
        return (
          <GradePointAverageField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "act":
        return (
          <ActScoreField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "sat":
        return (
          <SatScoreField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "gender_select":
        return (
          <GenderSelectField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "weight":
        return (
          <WeightInput
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "shirt_select":
        return (
          <TshirtField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "age_group_select":
        return (
          <AgeGroupSelect
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "years_in_sport":
        return (
          <YearsInSportField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "graduation_year":
      case "grad_year":
        return (
          <GradYearSelect
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "position":
        return (
          <PositionSelect
            {...fieldProps}
            position={formData.position || ""}
            sport={sport}
            price_points={price_points}
            full_position_price_points={full_position_price_points}
            className={classNames}
            {...ariaProps}
          />
        );
      case "state":
      case "states":
        return (
          <StateSelectField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "group_number":
        return (
          <TextField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "text_input":
      case "high_school":
      case "club_team":
        return (
          <TextField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "text_area":
        return (
          <TextArea
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "phone":
      case "phone_number":
        return (
          <PhoneNumberInput
            {...fieldProps}
            placeholder={`Enter ${fieldProps.label}`}
          />
        );
      case "url":
        return (
          <URLField
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "medications":
      case "conditions":
      case "allergies":
      case "roommate_preference":
      case "peers_attending":
      case "notes":
      case "text":
        return (
          <TextArea
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "asthma":
      case "diabetes":
      case "boolean":
      case "checkbox":
        return (
          <Checkbox
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "emergency_contact":
        return (
          <EmergencyContactInput
            {...fieldProps}
            className={classNames}
            {...ariaProps}
          />
        );
      case "emergency_contact_number":
        return (
          <EmergencyContactNumberInput
            key={dp.id}
            formData={formData}
            formDataPhoneNumber={formData.emergency_contact_number}
            countryCode={formData.emergencyContactCountryCode}
            countryCodeDropdownChanged={countryCodeDropdownChanged}
            handlePhoneChange={handlePhoneChange}
            className={classNames}
            {...ariaProps}
          />
        );
      case "physician":
        return (
          <PhysicianInfoForm
            key={dp.id}
            state={formData}
            name={dp.field_name}
            handleChange={handleChange}
            className={classNames}
            {...ariaProps}
          />
        );
      case "physician_contact_number":
        return (
          <PhysicianContactNumberInput
            key={dp.id}
            name={dp.field_name}
            state={formData}
            handleChange={handleChange}
            className={classNames}
            {...ariaProps}
          />
        );
      case "date":
        return (
          <DateDropdown
            label={dp.label}
            name={dp.field_name}
            value={formData[dp.field_name] || new Date()}
            onChange={(newValue) => handleDateChange(dp.field_name, newValue)}
            key={dp.id}
            className={classNames}
            {...ariaProps}
          />
        );
      case "birth_date":
        return (
          <BirthDateSelect
            birth_date={formData.birth_date}
            name="birth_date"
            value={formData[dp.field_name] || "2001-01-01"}
            onChange={dateChanged}
            key={dp.id}
            className={classNames}
            {...ariaProps}
          />
        );
      default:
        return (
          <div key={dp.id} style={{ marginBottom: "1em" }}>
            Unsupported field type "{dp.field_type}" for field "{dp.field_name}"
          </div>
        );
    }
  };

  function getDefaultValue(dp) {
    switch (dp.field_type) {
      case "date":
      case "birth_date":
        return "2001-01-01";
      case "number":
      case "integer":
        return 0;
      case "boolean":
      case "checkbox":
        return false;
      default:
        return "";
    }
  }

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    let countryCode =
      name === "guardianContactNumber"
        ? formData.guardianContactCountryCode
        : formData.emergencyContactCountryCode;

    setFormData((prevState) => ({
      ...prevState,
      [name]: countryCode + " " + value,
    }));
  };

  const dateChanged = (newDate) => {
    setFormData((prevState) => ({ ...prevState, birth_date: newDate }));
  };

  const stateDropdownChanged = (newState) => {
    setFormData((prevState) => ({ ...prevState, state: newState }));
  };

  const countryCodeDropdownChanged = (newCode) => {
    setFormData((prevState) => ({
      ...prevState,
      emergencyContactCountryCode: newCode,
    }));
  };

  const missingLabels = getMissingFieldLabels();
  const buttonTooltip =
    missingLabels.length > 0
      ? `Missing required fields: ${missingLabels.join(", ")}`
      : "";

  return (
    <form className="new-step-form" autoComplete="off" onSubmit={handleSubmit}>
      <div className="buck-test">
        <h1 className="form-heading">Registration Information</h1>
      </div>

      {data_points.map((dp) => renderField(dp))}
      
      {missingLabels.length > 0 && (
        <div
          id="form-error-region"
          aria-live="polite"
          className="error-message-container"
        >
          <div className="error-content">
            <h4><i className="fas fa-exclamation-triangle" aria-hidden="true"></i> Please fill in the following required fields: </h4>
            {missingLabels.join(", ")}
          </div>
        </div>
        )}

      <button
        type="submit"
        className="button button-primary create"
        style={buttonStyles}
        disabled={!allRequiredFieldsFilled()}
        title={buttonTooltip}
      >
        Next Step
      </button>
    </form>
  );
};

export default CustomInfoForm;
